import request from 'crm/utils/request'
import {format} from 'utils'
import api from 'crm/common/api/group-sop'
import {stringify} from 'qs'

export async function tasksInfo(params = {}) {
    return request(`${format(api.tasksInfo.url, {task_id: params.task_id})}?${stringify(params)}`)
}
